// src/components/WelcomeModal.js — extracted from App.js
import React, { useState } from "react";
import { CAPABILITIES, TOUR_STEPS } from "../constants";

// ─── Welcome Modal ────────────────────────────────────────────────────────────
export function WelcomeModal({ session, onClose, onTour, setView }) {
  const role = session?.user?.roles?.[0] || session?.user?.role || "buyer";
  const caps = CAPABILITIES[role] || CAPABILITIES.buyer;
  const name = session?.user?.name?.split(" ")[0] || "there";
  return (
    <div className="overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div className="modal fade-in" style={{maxWidth:520,maxHeight:"88vh",overflowY:"auto",padding:0}}>
        <div style={{background:"#111118",padding:"24px 28px",borderRadius:"16px 16px 0 0",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:"#fff",marginBottom:4}}>Welcome, {name} ✦</div>
            <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#B8860B",letterSpacing:"0.15em",textTransform:"uppercase"}}>{role} · THC.watch</div>
          </div>
          <button onClick={onClose} style={{background:"none",color:"#6B7280",fontSize:20,lineHeight:1,marginTop:-2}}>×</button>
        </div>
        <div style={{padding:"20px 28px"}}>
          <p style={{fontSize:13,color:"var(--ink3)",marginBottom:20,lineHeight:1.6}}>Here's everything you can do on the platform as a <strong>{role}</strong>:</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:24}}>
            {caps.map(c=>(
              <div key={c.title} onClick={()=>{onClose();if(c.nav)setView(c.nav);}} style={{background:"var(--bg2)",borderRadius:12,padding:"12px 14px",cursor:c.nav?"pointer":"default",border:"1px solid var(--bd)"}}>
                <div style={{fontSize:22,marginBottom:6}}>{c.icon}</div>
                <div style={{fontSize:12,fontWeight:600,color:"var(--ink)",marginBottom:3}}>{c.title}</div>
                <div style={{fontSize:11,color:"var(--ink3)",lineHeight:1.5}}>{c.desc}</div>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:10}}>
            <button className="btn-ink" style={{flex:1,padding:"11px 0",justifyContent:"center"}} onClick={onTour}>Take a tour →</button>
            <button className="btn-ghost" style={{flex:1,padding:"11px 0",justifyContent:"center"}} onClick={onClose}>I'll explore myself</button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ─── Tour Modal ───────────────────────────────────────────────────────────────
export function TourModal({ steps, onClose, setView }) {
  const [step, setStep] = useState(0);
  const [mini, setMini]  = useState(false); // collapsed pill mode after "Go there"
  const s = steps[step];
  const isLast = step === steps.length - 1;

  const goThere = () => {
    if (s.nav) setView(s.nav);
    setMini(true); // collapse so user can see the page
  };

  const expand = () => setMini(false);

  const next = () => {
    if (isLast) { onClose(); return; }
    setStep(p => p + 1);
    setMini(false);
  };

  const back = () => { setStep(p => p - 1); setMini(false); };

  // ── Mini pill (floating, non-blocking) ────────────────────────────────────
  if (mini) {
    return (
      <div style={{position:"fixed",bottom:24,left:"50%",transform:"translateX(-50%)",zIndex:500,display:"flex",alignItems:"center",gap:10,background:"#111118",borderRadius:50,padding:"10px 18px",boxShadow:"0 4px 24px rgba(0,0,0,.25)"}}>
        <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,color:"#B8860B"}}>{step+1}/{steps.length}</div>
        <div style={{fontSize:12,color:"#fff",fontWeight:500,maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.icon} {s.title}</div>
        <button onClick={expand}  style={{background:"rgba(255,255,255,.12)",color:"#fff",border:"none",borderRadius:20,padding:"4px 12px",fontSize:11,cursor:"pointer"}}>↑ Expand</button>
        <button onClick={next}    style={{background:"var(--accent)",color:"#fff",border:"none",borderRadius:20,padding:"4px 12px",fontSize:11,cursor:"pointer"}}>{isLast?"Done ✓":"Next →"}</button>
        <button onClick={onClose} style={{background:"none",color:"#6B7280",border:"none",fontSize:16,cursor:"pointer",lineHeight:1}}>×</button>
      </div>
    );
  }

  // ── Full modal ────────────────────────────────────────────────────────────
  return (
    <div className="overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div className="modal fade-in" style={{maxWidth:380,padding:0,overflow:"hidden"}}>
        <div style={{background:"#111118",padding:"10px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#B8860B",letterSpacing:"0.15em"}}>TOUR · {step+1} / {steps.length}</div>
          <button onClick={onClose} style={{background:"none",color:"#6B7280",fontSize:18,lineHeight:1}}>×</button>
        </div>
        <div style={{height:3,background:"#E4E4E7"}}>
          <div style={{height:"100%",background:"var(--accent)",width:`${((step+1)/steps.length)*100}%`,transition:"width .3s"}}/>
        </div>
        <div style={{padding:"28px 28px 24px"}}>
          <div style={{fontSize:36,marginBottom:14}}>{s.icon}</div>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:"var(--ink)",marginBottom:10}}>{s.title}</div>
          <div style={{fontSize:13.5,color:"var(--ink3)",lineHeight:1.7,marginBottom:24}}>{s.desc}</div>
          <div style={{display:"flex",gap:5,justifyContent:"center",marginBottom:20}}>
            {steps.map((_,i)=>(
              <div key={i} onClick={()=>{setStep(i);setMini(false);}} style={{width:6,height:6,borderRadius:"50%",background:i===step?"var(--accent)":"var(--bd)",cursor:"pointer",transition:"background .2s"}}/>
            ))}
          </div>
          <div style={{display:"flex",gap:10}}>
            {step > 0 && <button className="btn-ghost" style={{flex:1,padding:"10px 0",justifyContent:"center"}} onClick={back}>← Back</button>}
            {s.nav && <button className="btn-ghost" style={{flex:1,padding:"10px 0",justifyContent:"center"}} onClick={goThere}>Go there ↗</button>}
            <button className="btn-ink" style={{flex:1,padding:"10px 0",justifyContent:"center"}} onClick={next}>{isLast?"Done ✓":"Next →"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

